import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultGridElementDecoratorResource,
    GridElementDecoratorMutationResourceSchema,
    useGridElementDecoratorActions,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementDecoratorResource';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../util/useSelectorFunctions';
import { GridElementDecoratorContent } from './GridElementDecoratorContent';

export const GridElementDecoratorEditDialog = ({
    onClose,
    objectId,
    versionedInId,
}: {
    onClose: () => void;
    objectId: string | undefined | null;
    versionedInId: string;
}) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const gridElementDecoratorActions = useGridElementDecoratorActions();
    const gridElementDecoratorQuery = gridElementDecoratorActions.useGetResourceByObjectIdAndVersionedIn(
        objectId,
        versionedInId
    );
    const updateGridElementDecorator = gridElementDecoratorActions.useUpdateResource();
    const validation = gridElementDecoratorActions.useValidateResource(
        gridElementDecoratorQuery.data?.id,
        validationScope
    );

    const { form, formNames, onSubmit } = useMyForm({
        schema: GridElementDecoratorMutationResourceSchema,
        defaultValues: defaultGridElementDecoratorResource,
        submitHandler: async (data) => {
            await updateGridElementDecorator.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: gridElementDecoratorQuery.data,
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Edit Grid Element Decorator'}
            resourceType={ResourceType.GRID_ELEMENT_DECORATOR}
            resourceValidationResult={validation.data}
            metaDataInfo={gridElementDecoratorQuery.data}
        >
            <QueryBaseComponent name="GridElementDecorator" query={gridElementDecoratorQuery}>
                <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                    <GridElementDecoratorContent
                        form={form}
                        formNames={formNames}
                        readOnly={readOnly}
                        id={gridElementDecoratorQuery.data?.id}
                    />
                </Form_DisplayComponentBaseView>
            </QueryBaseComponent>
        </EditChildBaseDialog>
    );
};
